module.exports = __webpack_public_path__ + "img/solutions--easier_patient_transfer.f1d53160.png";